import Forms from "./Forms";
import React from "react";

const EmailsEditor = ({items = [], onChange}) => {
    const update = (i, patch) => {
        const copy = [...items];
        copy[i] = {...copy[i], ...patch};
        onChange(copy);
    };
    const remove = (i) => {
        const next = items.filter((_, idx) => idx !== i);
        onChange(next.length ? next : [{value: '', primary: true}]);
    };
    const setPrimary = (i) => onChange(items.map((e, idx) => ({...e, primary: idx === i})));

    return (
        <div className="space-y-2">
            {items.map((e, i) => (
                <div key={i} className="grid grid-cols-1 md:grid-cols-5 gap-3 items-end">
                    <Forms.Text label="Email" value={e.value} onChange={v => update(i, {value: v})}/>
                    <Forms.Checkbox label="Primární" value={!!e.primary} onChange={() => setPrimary(i)}/>
                    <div className="md:col-span-3">
                        <div className="opacity-50 text-xs mt-2"></div>
                        {items.length > 1 && <Forms.Button type="button" variant="danger" label="–" onClick={() => remove(i)}/>}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default EmailsEditor;